import '../../scss/news.scss';
import '../common/share';
import '../common/slider';
import'../common/seeMoreResults';

const $ = require('jquery');

import Player from '@vimeo/player';

const container = document.querySelector('#header');
const bannerContent = document.querySelector('.banner-news-content');

document.addEventListener('DOMContentLoaded', () => {
    initFilters();
    initPlayers();

    if (bannerContent !== null) {
        window.addEventListener('scroll', triggerBannerContent, {
            passive: true,
            capture: true
        });
    }
});

const triggerBannerContent = () => {
    if (window.scrollY > container.offsetTop) {
        bannerContent.classList.add('active');
    } else {
        bannerContent.classList.remove('active');
    }
};

const initFilters = () => {
    const filterCategory = $('#category');

    filterCategory.select2({
        allowClear: true,
        placeholder: filterCategory.attr('data-placeholder')
    });

    filterCategory.on('change.select2', function () {
        window.location.href = $(this).closest('form').attr('action') + '?category=' + $('#category').val();
        $(this).closest('form').trigger('submit');
        $(this).prop('disabled', true);
    });
}

const initPlayers = () => {
    const players = document.querySelectorAll('.player');
    Array.from(players).forEach(playerCtn => {
        new Player(playerCtn, {
            url: playerCtn.getAttribute('data-video-url'),
            byline: false,
            portrait: false,
            color: 'FFFFFF',
            pip: true
        });
    });
}
